import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

// Singe item view state

export const fetchItem = createAsyncThunk(
  'item/get',
  async (data, thunkAPI) => {
    try {
      const { ownerId, itemId } = data;
      const response = await api.getItem(ownerId, itemId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: item/get', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveItem = createAsyncThunk(
  'item/save',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, itemId, itemData } = data;

      const response = await api.saveItem(itemOwnerId, itemId, itemData);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }

    } catch(e) {
      console.error('ERROR: item/save', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)

export const fetchTreadItem = createAsyncThunk(
  'tread-item/get',
  async (data, thunkAPI) => {
    try {
      const { ownerId, itemId } = data;
      const response = await api.getTreadItem(ownerId, itemId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: item/get', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveTreadItem = createAsyncThunk(
  'tread-item/save',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, itemId, itemData } = data;

      const response = await api.saveTreadItem(itemOwnerId, itemId, itemData);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }

    } catch(e) {
      console.error('ERROR: item/save', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)


const initialState = {
  editableFields: [],
  canEdit: false,
  item: {},
  fetchStatus: 'idle',
  fetchError: null,
  saveStatus: 'idle',
  saveError: null
};

export const itemsSlice = createSlice({
  name: 'item',
  initialState,
  reducers: {
    clearSaveStatus: (state, action) => {
      state.saveStatus = 'idle';
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchItem.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;
      state.editableFields = action.payload.edit || [];
      state.canEdit = action.payload.canEdit;
      state.item = action.payload.item || {};
    },
    [fetchItem.pending]: (state, action) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchItem.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.fetchStatus = 'failed';
      state.fetchError = message;
    },

    [saveItem.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
    },
    [saveItem.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveItem.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.saveStatus = 'failed';
      state.saveError = {
        message: message,
        fields: action.payload.result?.errors
      };
    },

    // treads
    [fetchTreadItem.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;
      state.editableFields = action.payload.edit || [];
      state.canEdit = action.payload.canEdit;
      state.item = action.payload.item || {};
    },
    [fetchTreadItem.pending]: (state, action) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchTreadItem.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.fetchStatus = 'failed';
      state.fetchError = message;
    },

    [saveTreadItem.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
    },
    [saveTreadItem.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveTreadItem.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.saveStatus = 'failed';
      state.saveError = {
        message: message,
        fields: action.payload.result?.errors
      };
    },
  }
});

export const { clearSaveStatus } = itemsSlice.actions;

export const selectItem = state => state.item;

export const selectFetchStatus = state => ({
  fetchStatus: state.item.fetchStatus,
  fetchError: state.item.fetchError,
  item: state.item.item
});

export const selectAccess = state => state.item.canEdit;

export default itemsSlice.reducer;
